import React from "react";
import ReactDOM from "react-dom";

const ProductImageZoomViewer = (props) => {
  const handleBackdropClick = (e) => {
    // Solo cerrar si se hace clic en el backdrop, no en el contenido
    if (e.target === e.currentTarget) {
      props.closeModal();
    }
  };

  // Usar Portal para renderizar el modal fuera del card
  return ReactDOM.createPortal(
    <div className="image-zoom-overlay" onClick={handleBackdropClick}>
      <div className="image-zoom-modal">
        <div className="image-zoom-header">
          <h5 className="image-zoom-title">
            {props.item.Familia} {props.item.Codigo} (Zoom)
          </h5>
          <button
            type="button"
            className="image-zoom-close"
            onClick={props.closeModal}
            aria-label="Cerrar"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="image-zoom-body">
          <img
            alt={props.item.Codigo}
            src={props.imageSource}
            className="image-zoom-img"
          />
        </div>
        <div className="image-zoom-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={props.closeModal}
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ProductImageZoomViewer;
